const MAX_SEGMENT_LENGTH = 40;

/**
 * ファイル名として使えない文字列をサニタイズする。
 */
export function sanitizeFilename(name: string): string {
  if (!name) {
    return "";
  }
  const trimmed = name.trim();
  const withoutForbidden = trimmed.replace(/[\\/:*?'"<>|]+/g, "");
  const replacedWhitespace = withoutForbidden.replace(/\s+/g, "-");
  const collapsed = replacedWhitespace.replace(/-+/g, "-");
  const cleaned = collapsed.replace(/^-|-$/g, "");

  return cleaned;
}

function truncateSegment(
  value: string,
  maxLength = MAX_SEGMENT_LENGTH,
): string {
  if (value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, maxLength - 1)}…`;
}

/**
 * 出力種別・プロジェクト・ラベル・タイムスタンプを組み合わせて一意なファイル名を生成する。
 *
 * 例: `sa_project_label_YYYYMMDDHHmmss`
 */
export function buildProjectCaptureFilename(
  type:
    | "dash"
    | "iw"
    | "iw_status"
    | "iw_urls"
    | "sa"
    | "sa_detail"
    | "sa_comparing"
    | "ua"
    | "ua_detail"
    | "ua_comparing"
    | "ua_sessions"
    | "ads",
  projectName: string,
  label: string,
): string {
  const timestamp = new Date()
    .toISOString()
    .replace(/[-:T.Z]/g, "")
    .slice(0, 14);
  const projectKey = truncateSegment(sanitizeFilename(projectName));
  const labelKey = truncateSegment(sanitizeFilename(label));
  return `${type}_${projectKey}_${labelKey}_${timestamp}`;
}
